import { useEffect, type FC } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import { PAY_TYPE_ENUM, PAY_TYPE_MAP } from "../../utils/constants";
import { QRCodeSVG } from "qrcode.react";
import background from "../../images/background.jpg";

type PayModalProps = {
  qrCodeUrl: string;
  open: boolean;
  onCloseClick: () => void;
  payType: PAY_TYPE_ENUM | null;
  onPayedClick: () => void;
};

export const PayModal: FC<PayModalProps> = ({
  open,
  onCloseClick,
  payType,
  onPayedClick,
  qrCodeUrl,
}) => {
  useEffect(() => {
    // call API to get QR code url
    console.log(" -> PayModal-useEffect, payType:", payType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "400px",
          height: "500px",
          backgroundColor: "white",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "24px",
          backgroundImage: `url(${background})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Typography variant="h5" fontWeight={800}>
          请扫码支付！
        </Typography>
        <Typography variant="h6" fontWeight={800} color="secondary">
          {payType === PAY_TYPE_ENUM.yearly
            ? `您选择了 ${PAY_TYPE_MAP.yearly}`
            : `您选择了 ${PAY_TYPE_MAP.monthly}`}
        </Typography>

        <QRCodeSVG value={qrCodeUrl} width="300px" height="300px" />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "24px",
            padding: "0 24px",
            width: "100%",
          }}
        >
          <Button
            fullWidth
            variant="contained"
            onClick={onPayedClick}
            sx={{
              fontWeight: 800,
              fontSize: "15px",
            }}
            color="success"
          >
            支付完成
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={onCloseClick}
            sx={{
              fontWeight: 800,
              fontSize: "15px",
            }}
            color="secondary"
          >
            退出
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
